module.exports = __webpack_public_path__ + "static/img/carousel_5_nx3ajx_ar_16_9_w_1757.e8dcda1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_5_nx3ajx_ar_16_9_w_1757.jpg
// module id = vHYX
// module chunks = 0